import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SubSink } from '@core/utils/subsink';
import { BlockActionType } from '@core/enums';
import { BlockAction, ViewPart } from '@core/models';
import { Block } from '@core/models/block/block.model';
import { ButtonHandlerService } from '@core/services/button-handler.service';
import { ShoppingCartService } from '@shared/services/cart/shopping-cart.service';
import { SessionStorageService } from '@app/shared/services/storage';

const filterRedirect = (action: BlockAction) => action?.actionType === BlockActionType.REDIRECT;

@Component({
    selector: 'shopping-cart',
    templateUrl: './shopping-cart.component.html',
    standalone: false
})
export class ShoppingCartComponent implements OnInit, OnDestroy {
  @Input() specialBlock: Block;
  cart: Block | undefined;
  buttonClick$: Observable<BlockAction> = this.buttonService.click$;
  locale = this.storageService.getItem('language');
  private subSink = new SubSink();

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private buttonService: ButtonHandlerService,
    private storageService: SessionStorageService,
  ) {
  }

  ngOnInit(): void {

    this.cart = this.specialBlock.children.find(b => b.settings.viewPart === ViewPart.CART_TOGGLE);

    this.subSink.sink = this.shoppingCartService.shoppingCart$.subscribe();

    this.subSink.sink = this.shoppingCartService.items$.subscribe();

    // redirect subscription
    this.subSink.sink = this.buttonClick$
      .pipe(
        filter(filterRedirect),
        map(({actionData}) => actionData.url))
      .subscribe((next: string) => {
        this.router.navigateByUrl(this.locale + next);
      });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
